/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Actions/Content/LetterNewOld/DocumentTemplate/Content",
  disabled,
  onChange
  
}) {
let documentTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'document_templates',
})
let formActionDocumentTemplateValueData = fromData.useDataValue({ viewPath,
context: 'form',
path: 'action.document_template',
})
let formActionDocumentTemplateChangeData = fromData.useDataChange({ viewPath,
context: 'form',
path: 'action.document_template',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 required={true}
 data="document_templates"
 from={documentTemplatesValueData}
 disabled={disabled}
 allowEmptyChoice={false}
 placeholder="Select document template"
 data="form.action.document_template"
 value={formActionDocumentTemplateValueData}
 onChange={formActionDocumentTemplateChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Document template"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}